import { createAsyncThunk } from '@reduxjs/toolkit';
import logger from 'src/logger';
import { miniSerializeErrorOverride } from './serialize-error';
import { TSession } from 'src/types/session.type';
import { validateAdminPanelToken } from 'src/services/token/token.service';

export const validateAdminPanelTokenAction = createAsyncThunk(
  'validate/adminPanelToken',
  async (token: TSession['token']) => {
    try {
      const response = await validateAdminPanelToken(token);
      return response;
    } catch (err) {
      logger.reportError(err, { message: 'Error in validateAdminPanelTokenAction' });
      throw err;
    }
  },
  {
    serializeError: miniSerializeErrorOverride,
  },
);
